import React, { Suspense } from 'react';

const MarkdownRenderer = React.lazy(() => import('./MarkdownRenderer'));

interface Props {
  children: string;
  useGfm?: boolean;
}

interface BoundaryState {
  hasError: boolean;
}

class MarkdownErrorBoundary extends React.Component<
  { children: React.ReactNode; fallback: string },
  BoundaryState
> {
  constructor(props: { children: React.ReactNode; fallback: string }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): BoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <div style={{ whiteSpace: 'pre-wrap' }}>{this.props.fallback}</div>;
    }
    return this.props.children;
  }
}

const SafeMarkdown: React.FC<Props> = ({ children, useGfm }) => {
  return (
    <MarkdownErrorBoundary fallback={children}>
      <Suspense fallback={null}>
        <MarkdownRenderer useGfm={useGfm}>{children}</MarkdownRenderer>
      </Suspense>
    </MarkdownErrorBoundary>
  );
};

export default SafeMarkdown;
